import { NavLink, useNavigate, useParams } from "react-router-dom"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import styles from "./about-card.module.css"
import { useDispatch, useSelector } from "react-redux"
import {
  getCard,
  getCard3,
  responseStatus,
  getRecommendedPosts,
  responseStatusThen,
} from "../../../utils/api"
import { setIsLoading } from "../../../services/reducers/preloader-slice"
import Preloader from "../../preloader/preloader"
import CanMightBeInteresting from "../../can-might-be-interesting/can-might-be-interesting"
import { setAuthChecked, setUser } from "../../../services/reducers/user-slice"
import {
  isClickEnter,
  isUserDelete,
} from "../../../services/reducers/modal-slice"
import { setCard } from "../../../services/reducers/single-card-slice"
import { setRecommendedPosts } from "../../../services/reducers/recommendedPosts-slice"
import SEO from "../../../utils/SEO"







function AboutCard() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { slug } = useParams()

  const card = useSelector((store) => store.singleCard.card)
  const isLoading = useSelector((store) => store.preloader.isLoading)
  // const object = useSelector((store) => store.cards.object)
  const recommendedPosts = useSelector(
    (store) => store.recommendedPosts.recommendedPosts
  )
  const [errorUrlHidden, setErrorUrlHidden] = useState(false)
  const [errorToken, setErrorToken] = useState(true)
  const logout = () => {
    navigate("/authorization")
    localStorage.removeItem("token")
    localStorage.removeItem("subscription")
    dispatch(setUser(null))
    dispatch(setAuthChecked(false))
    dispatch(isUserDelete(true))
    dispatch(isClickEnter(false))
    // window.location.reload()
  }
  useMemo(() => {
    dispatch(setIsLoading(true))

    getCard3(slug, errorToken)
      .then(async (res) => {
        const path = {
          404: "/not-found",
          // 401: "/authorization",
          403: "/error-403",
          500: "/error-500",
        }

        if (res.ok) {
          const data = await res.json()
          dispatch(setCard(data))
        } else if (res.status in path) {
          setErrorToken(false)
          navigate(path[res.status])
        } else {
          setErrorToken(false)
          return res.json()
        }
      })
      .then((res) => {
        if (!!res) {
          console.log(res.detail)
        }
        if (!!res && res.detail === "Недопустимый токен.") {
          logout() // Включить для выброса!!!!!!!!!!!!!!!!!
        }
      })
      .finally(() => {
        dispatch(setIsLoading(false))
      })

    getRecommendedPosts(slug).then((res) => {
      dispatch(setRecommendedPosts(res))
    })
  }, [slug, navigate, errorToken])

  // const subscriptionUnity = localStorage.getItem("subscriptionUnity")
  const subscriptionUser = JSON.parse(localStorage.getItem("subscription"))
  // const subscriptionIdeas = localStorage.getItem("subscriptionIdeas")

  const token = localStorage.getItem("token")
  const isAuthenticated = !!token

  // console.log(errorToken);

  const checkSubscribe = (cardSubscribe) => {
    if (subscriptionUser) {
      return subscriptionUser.some((el) => {
        return el.subscription === cardSubscribe
      })
    }
    return false
  }

  // замена ссылки
  function addLink() {
    let element = document.getElementById("sectionCard")
    let selection = window.getSelection()
    //Итоговый скопированный текст
    let copytext =
      `${card.name}` + "\n" + "Читайте на сайте: " + document.location.href
    let newdiv = document.createElement("div")
    newdiv.style.position = "absolute"
    newdiv.style.left = "-99999px"
    element.appendChild(newdiv)
    newdiv.innerText = copytext
    selection.selectAllChildren(newdiv)
    window.setTimeout(function () {
      element.removeChild(newdiv)
    }, 0)
  }
  document.oncopy = addLink
  // console.log(card.text );
  // const block = document.getElementById('fixedSection'); // Замените 'yourBlockId' на ID вашего блока
  // const footer = document.querySelector('footer');
  const [fixedBottom, setFixedBottom] = useState(false)
  const [marginValue, setMarginValue] = useState(false)
  const componentRef = useRef(null)
  const fixedSectionComponentRef = useRef(null)
  const topRectFreezeRef = useRef(null)
  const triggerTop = useRef()

  const scrollHandler = useCallback(() => {
    let viewportHeight = document.body.scrollHeight - 224 // Высота видимой части окна
    let scrollY = window.pageYOffset // Величина прокрутки по вертикали
    let innertHeight = window.innerHeight
    let topRect 
    // let distanceToPageEnd
    if (fixedSectionComponentRef.current) {
      const blockRect = fixedSectionComponentRef.current.getBoundingClientRect()
      topRect = blockRect

      if (!topRectFreezeRef.current) {
        topRectFreezeRef.current = topRect.bottom
      }
      if (!triggerTop.current) {
        triggerTop.current = viewportHeight - topRectFreezeRef.current
      }
      
      // console.log(triggerTop.current );
      // console.log(triggerTop.current );
      
      if (scrollY + topRectFreezeRef.current > viewportHeight) {
        setFixedBottom(true)
      } else {
        setFixedBottom(false)
      }
    }

    let top
    if (componentRef.current) {
      const topCurrent = componentRef.current.getBoundingClientRect()
      top = topCurrent.top
    }

    const isVisible = top >= 0 && top <= window.innerHeight

    if (isVisible) {
      setMarginValue(false)
    } else {
      if (componentRef.current) {setMarginValue(true)}
      
    }
  },[fixedSectionComponentRef.current])


// if (fixedSectionComponentRef.current) {
//   disableScroll(false)
// }
useEffect(() => {
if (!recommendedPosts.length) {    
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';}
    else {
      document.documentElement.style.overflow = 'auto';
      document.body.style.overflow = 'auto';
    }
},[recommendedPosts.length])



  useEffect(() => {

    window.addEventListener("scroll", scrollHandler, false)
    return () => window.removeEventListener("scroll", scrollHandler, false)
  }, [scrollHandler])

// console.log(recommendedPosts);



  return (
    <>
      <div className={styles.headerContainer} />
      <section className={styles.card}>
        {/*
                  =============== isLoading ? ================
                  */}
        {isLoading ? (
          <div className={styles.preloader}>
            <Preloader />
          </div>
        ) : (
          <div className={styles.mainScreen}>
            <SEO
              title={card.name}
              description={card.description}
              ogTitle={card.name}
              ogDescription={card.description}
            />
            <div className={styles.sectionCard} id={"sectionCard"}>
              <div
                className={`${
                  checkSubscribe(card.subscription) ||
                  card.subscription === null
                    ? styles.aboutCard
                    : styles.aboutCardBlur
                }`}
              >
                <div className={styles.navigationBox}>
                  <NavLink to={"/"} className={styles.link}>
                    <div className={styles.arrow}></div>
                    Главная
                  </NavLink>

                  <NavLink to={"/analytics-and-news"} className={styles.link}>
                    <div className={styles.arrow}></div>
                    Аналитика и Новости
                  </NavLink>
                </div>

                <div className={styles.headerTitleWrapper}>
                  <span className={styles.pubDate}>
                    {card.pub_date_formated}
                  </span>
                  <h3 className={styles.title}>{card.name}</h3>
                  <span className={styles.desc}>{card.description}</span>
                  <div
                    className={styles.container}
                    /*style={{maxWidth: '1200px', margin: "auto", wordWrap: "break-word"}}*/
                    dangerouslySetInnerHTML={{ __html: card.text }}
                  ></div>
                </div>
              </div>

              {/*
                  =============== Preloader ================
                  Скрыть блок после скролла 
                  */}

              {isLoading ? (
                <Preloader />
              ) : (
                <div className={styles.monitorWrapper} ref={componentRef}>
                  <div
                    className={
                      marginValue &&
                      (checkSubscribe(card.subscription) ||
                        card.subscription === null)
                        ? styles.monitorHidden
                        : styles.monitor
                    }
                  >
                    {<CanMightBeInteresting posts={recommendedPosts} />}
                  </div>
                </div>
              )}
            </div>

            {/*
            Отображение фиксированного блока 
            */}
            {marginValue &&
              (checkSubscribe(card.subscription) ||
                card.subscription === null) && (
                <div
                  className={
                    fixedBottom
                      ? styles.monitorFixedBottom
                      : styles.monitorFixed
                  }
                  
                >
                  <div className={styles.sectionCard2} id="fixedSection" ref={fixedSectionComponentRef}>
                    <div className={styles.aboutCard} style={{ width: "90%" }}>
                      <div
                        className={styles.headerTitleWrapper}
                        style={{ "background-color": "#047337" }}
                      ></div>
                    </div>
                    <div className={styles.monitorWrapper}>
                      <CanMightBeInteresting posts={recommendedPosts} />
                    </div>
                  </div>
                </div>
              )}
            {/*
            {errorUrlHidden && (
              <div className={styles.notFoundWrapper}>
                <NotFound hidden={"none"} />
              </div>
            )}
            */}

            {/*
                  =============== isAuthenticated && card.subscription ? ================
                  */}
            {!checkSubscribe(card.subscription) &&
              card.subscription !== null && (
                <div className={styles.authBox}>
                  <h3
                    className={styles.authTitle}
                  >{`Материал доступен с подпиской ${
                    card.subscription ? card.subscription : ""
                  }`}</h3>
                  <NavLink
                    to={"/profile"}
                    // target={"_blank"}
                    className={styles.button}
                  >
                    <div className={styles.buttonTxt}>Оформить подписку</div>
                  </NavLink>
                  <div className={styles.subTxtWrapper}>
                    <div className={styles.authText}>
                      Остались вопросы? Вы всегда можете{" "}
                      <a
                        href={"https://t.me/ie_contact"}
                        target={"_blank"}
                        className={styles.authLink}
                      >
                        связаться с нами
                      </a>
                    </div>
                    <div className={styles.authText}>
                      Если подписка уже есть, то{" "}
                      <NavLink
                        to={"/authorization"}
                        className={styles.authLink}
                      >
                        Войдите
                      </NavLink>
                    </div>
                  </div>
                </div>
              )}

            {/*
                  =============== CanMightBeInteresting ================
                  */}
            
            <div className={styles.phone}>
              {!errorUrlHidden && (
                <CanMightBeInteresting
                  hidden={"none"}
                  posts={recommendedPosts}
                
                />
              )}
            </div>
            
          </div>
        )}
      </section>
    </>
  )
}

export default AboutCard
